import { 
    CLEAR_GET_PENDING_VEHICLE_INSPECTION_STATE,
    GET_INSPECTION_CHECKLIST_FAIL, 
    GET_INSPECTION_CHECKLIST_LOADING, 
    GET_INSPECTION_CHECKLIST_SUCCESS, 
    GET_LICENSE_STATUS_FAIL, 
    GET_LICENSE_STATUS_LOADING, 
    GET_LICENSE_STATUS_SUCCESS, 
    GET_PENDING_VEHICLE_INSPECTION_FAIL, 
    GET_PENDING_VEHICLE_INSPECTION_LOADING, 
    GET_PENDING_VEHICLE_INSPECTION_SUCCESS, 
    GET_VEHICLE_ROUTE_INSPECTION_FAIL, 
    GET_VEHICLE_ROUTE_INSPECTION_LOADING, 
    GET_VEHICLE_ROUTE_INSPECTION_SUCCESS, 
    GET_VEHICLE_ROUTES_FAIL, 
    GET_VEHICLE_ROUTES_LOADING, 
    GET_VEHICLE_ROUTES_SUCCESS, 
    GET_VEHICLE_STATUS_FAIL, 
    GET_VEHICLE_STATUS_LOADING, 
    GET_VEHICLE_STATUS_SUCCESS, 
    POST_INSPECTION_CHECKLIST_FAIL, 
    POST_INSPECTION_CHECKLIST_LOADING,
    POST_INSPECTION_CHECKLIST_SUCCESS,
    POST_VEHICLE_INSPECTION_FAIL,
    POST_VEHICLE_INSPECTION_LOADING,
    POST_VEHICLE_INSPECTION_SUCCESS} from "../Components/Constants/ActionTypes";


const Inspections = (state,{type,payload})=>{
    switch (type) {
        case GET_INSPECTION_CHECKLIST_LOADING:
            return{
                ...state,
                getInspections:{
                ...state.getInspections,
                loading:true
              }
            };
        case GET_INSPECTION_CHECKLIST_SUCCESS:
            return {
                ...state,
                getInspections:{
                    ...state.getInspections,
                    loading:false,
                    data:payload,
                }
            };
        case GET_INSPECTION_CHECKLIST_FAIL:
            return{
                ...state,
                getInspections:{
                    ...state.getInspections,
                    loading:false,
                    error:payload,
                }
            };
        case POST_INSPECTION_CHECKLIST_LOADING:
            return{
                ...state,
                postInspections:{
                ...state.postInspections,
                loading:true
              }
            };
        case POST_INSPECTION_CHECKLIST_SUCCESS:
            return {
                ...state,
                postInspections:{
                    ...state.postInspections,
                    loading:false,
                    data:payload,
                }
            };
        case POST_INSPECTION_CHECKLIST_FAIL:
            return{
                ...state,
                postInspections:{
                    ...state.postInspections,
                    loading:false,
                    error:payload,
                }
            };
        case GET_VEHICLE_STATUS_LOADING:
            return{
                ...state,
                getVehicleStatus:{
                ...state.getVehicleStatus,
                loading:true
              }
            };
        case GET_VEHICLE_STATUS_SUCCESS:
            return {
                ...state,
                getVehicleStatus:{
                    ...state.getVehicleStatus,
                    loading:false,
                    data:payload,
                }
            };
        case GET_VEHICLE_STATUS_FAIL:
            return{
                ...state,
                getVehicleStatus:{
                    ...state.getVehicleStatus,
                    loading:false,
                    error:payload,
                }
            };
        case GET_PENDING_VEHICLE_INSPECTION_LOADING:
            return{
                ...state,
                fetchVehiclePendingInspection:{
                ...state.fetchVehiclePendingInspection,
                loading:true
              }
            };
        case GET_PENDING_VEHICLE_INSPECTION_SUCCESS:
            return {
                ...state,
                fetchVehiclePendingInspection:{
                    ...state.fetchVehiclePendingInspection,
                    loading:false,
                    data:payload,
                }
            };
        case GET_PENDING_VEHICLE_INSPECTION_FAIL:
            return{
                ...state,
                fetchVehiclePendingInspection:{
                    ...state.fetchVehiclePendingInspection,
                    loading:false,
                    error:payload,
                }
            };
        case CLEAR_GET_PENDING_VEHICLE_INSPECTION_STATE:
            return{
                ...state,
                fetchVehiclePendingInspection:{
                    data:[],
                    error:null,
                    loading:false,
                },
            };
        case POST_VEHICLE_INSPECTION_LOADING:
            return{
                ...state,
                addInspection:{
                ...state.addInspection,
                loading:true
              }
            };
        case POST_VEHICLE_INSPECTION_SUCCESS:
            return {
                ...state,
                addInspection:{
                    ...state.addInspection,
                    loading:false,
                    data:payload,
                }
            };
        case POST_VEHICLE_INSPECTION_FAIL:
            return{
                ...state,
                addInspection:{
                    ...state.addInspection,
                    loading:false,
                    error:payload,
                }
            };

        case GET_LICENSE_STATUS_LOADING:
            return{
                ...state,
                getLicenseStatus:{
                ...state.getLicenseStatus,
                loading:true
              }
            };
        case GET_LICENSE_STATUS_SUCCESS:
            return {
                ...state,
                getLicenseStatus:{
                    ...state.getLicenseStatus,
                    loading:false,
                    data:payload,
                }
            };
        case GET_LICENSE_STATUS_FAIL:
            return{
                ...state,
                getLicenseStatus:{
                    ...state.getLicenseStatus,
                    loading:false,
                    error:payload,
                }
            };
        case GET_VEHICLE_ROUTES_LOADING:
            return{
                ...state,
                getVehicleRoutes:{
                ...state.getVehicleRoutes,
                loading:true
              }
            };
        case GET_VEHICLE_ROUTES_SUCCESS:
            return {
                ...state,
                getVehicleRoutes:{
                    ...state.getVehicleRoutes,
                    loading:false,
                    data:payload,
                }
            };
        case GET_VEHICLE_ROUTES_FAIL:
            return{
                ...state,
                getVehicleRoutes:{
                    ...state.getVehicleRoutes,
                    loading:false,
                    error:payload,
                }
            };

        case GET_VEHICLE_ROUTE_INSPECTION_LOADING:
            return{
                ...state,
                getVehicleRouteInspections:{
                ...state.getVehicleRouteInspections,
                loading:true
              }
            };
        case GET_VEHICLE_ROUTE_INSPECTION_SUCCESS:
            return {
                ...state,
                getVehicleRouteInspections:{
                    ...state.getVehicleRouteInspections,
                    loading:false,
                    data:payload,
                }
            };
        case GET_VEHICLE_ROUTE_INSPECTION_FAIL:
            return{
                ...state,
                getVehicleRouteInspections:{
                    ...state.getVehicleRouteInspections,
                    loading:false,
                    error:payload,
                }
            };
    }
}


export default Inspections;